import React from "react";
import "./BottomHero.css";
import landing12 from "../../../../images/landing12.jpg";
import { FaRegCalendarAlt, FaPhoneAlt } from "react-icons/fa"; // icons
import { useNavigate } from "react-router-dom";

const BottomHero = () => {
  const navigate = useNavigate();
  return (
    <section
      className="bottomhero"
      style={{
        backgroundImage: `url(${landing12})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <h2 className="bottomhero-heading">Transform Your Hiring Process</h2>
      <p className="bottomhero-subheading">
        Empower your HR teams with AI-driven tools designed to simplify
        recruitment, save time, and hire the right candidates faster.
      </p>

      <div className="bottomhero-buttons">
        <button className="bottomhero-btn" onClick={()=>navigate("/contact-us")}>
          <FaRegCalendarAlt className="btn-icon" /> Request Demo
        </button>
        <button className="bottomhero-btn">
          <FaPhoneAlt className="btn-icon" onClick={()=>navigate("/contact-us")}/> Request Call
        </button>
      </div>
    </section>
  );
};

export default BottomHero;
